import { FrameContexts } from "@microsoft/teams-js";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { ManageBrowserHistory } from "../services/dependencies/manageBrowserHistory";
import { config } from "../state/config/config.selector";
import Styles from "./live.workspace.module.css";

type LiveWorkspaceProps = {
  isFullscreen: boolean;
  workspaceId: string;
  workspaceUrl: string | undefined;
};

type WorkspaceIframeProps = {
  workspaceId: string;
  workspaceUrl: string | undefined;
  allowFullScreen: boolean | undefined;
};

export const LiveWorkspace = ({
  isFullscreen,
  workspaceId,
  workspaceUrl,
}: LiveWorkspaceProps) => {
  const configuration = useSelector(config);
  const memoizedPropsForIframe: WorkspaceIframeProps = useMemo(
    () => ({
      workspaceId,
      workspaceUrl,
      allowFullScreen:
        isFullscreen && configuration.teamsFrame !== FrameContexts.sidePanel,
    }),
    [workspaceId, workspaceUrl, isFullscreen, configuration.teamsFrame],
  );

  return <WorkspaceIframe {...memoizedPropsForIframe} />;
};

const WorkspaceIframe = ({
  workspaceId,
  workspaceUrl,
  allowFullScreen,
}: WorkspaceIframeProps) => (
  <iframe
    className={`${Styles.liveWorkspacePreview} ${
      allowFullScreen ? Styles.fullScreen : Styles.hiddenIframe
    }`}
    history-state-value={ManageBrowserHistory.state()}
    id={workspaceId}
    name="iframes"
    src={workspaceUrl}
    title={workspaceId}
  />
);
